const CAMPAIGN_PARAMETER_MAP = {
  utm_source: "campaign_source",
  utm_medium: "campaign_medium",
  utm_campaign: "campaign_name",
  utm_content: "campaign_content",
} as const;

export type CampaignPropertyName =
  (typeof CAMPAIGN_PARAMETER_MAP)[keyof typeof CAMPAIGN_PARAMETER_MAP];

export type CampaignProperties = Partial<Record<CampaignPropertyName, string>>;

const MAX_CAMPAIGN_VALUE_LENGTH = 100;

export function normalizeCampaignValue(value: string): string | null {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, MAX_CAMPAIGN_VALUE_LENGTH)
    .replace(/-+$/g, "");
  return normalized || null;
}

export function readCampaignProperties(search?: string): CampaignProperties {
  const sourceSearch =
    search ?? (typeof window !== "undefined" ? window.location.search : "");
  const params = new URLSearchParams(sourceSearch);
  const properties: CampaignProperties = {};

  for (const [parameter, property] of Object.entries(CAMPAIGN_PARAMETER_MAP)) {
    const value = normalizeCampaignValue(params.get(parameter) ?? "");
    if (value) properties[property] = value;
  }

  return properties;
}
